module.exports = __webpack_public_path__ + "img/m-plan-1-4.ff6a8162.png";